<template>
    <!-- ** html -->
    <div v-if="col.textHtml" v-html="col.textHtml" />

    <!-- ** amount -->
    <span v-if="col.amount !== null && col.amount !== undefined">
        {{newCommonFormatCurrency(col.amount, undefined)}}
    </span>

    <!-- ** content -->
    <span v-else>
        {{ col.content }}
    </span>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

@Component
export class AuditCardCols extends Vue {
    @Prop({ type: Object, required: true }) col!: any

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, options);
    }

}
export default toNative(AuditCardCols);
</script>